import { GrowthBookProvider } from "@growthbook/growthbook-react";
import type React from "react";
import { useEffect } from "react";
import useAuth, { type AuthState } from "@/store/auth.slice";
import useNewsFeedsStore from "@/store/news-feeds/news-feeds.slice";
import { gb } from ".";

export const FeatureManagementProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const user = useAuth((state: AuthState) => state.user);
  const loggedIn = useAuth((state: AuthState) => state.loggedIn);
  const isEmployee = useAuth((state: AuthState) => state.isEmployee);
  const currentFeedId = useNewsFeedsStore((state) => state.currentFeedId);

  useEffect(() => {
    const attributes = {
      id: user?.id,
      loggedIn,
      email: user?.email,
      company: user?.default_tenant?.slug,
      employee: isEmployee,
      deviceId: currentFeedId ?? undefined,
    };

    gb.setAttributes(attributes);
  }, [
    user?.id,
    loggedIn,
    user?.email,
    user?.default_tenant?.slug,
    isEmployee,
    currentFeedId,
  ]);

  return <GrowthBookProvider growthbook={gb}>{children}</GrowthBookProvider>;
};
